import { DimmerWrapper } from "./DimmerStyles"

const Dimmer = () => {
  return (
    <DimmerWrapper> </DimmerWrapper>
  )
}

export default Dimmer